import type { DailySchedulePlan } from './types';

function vehicleHoldingJob(plan: DailySchedulePlan, jobId: string): string | undefined {
  for (const v of plan.vehicles) {
    if (v.legs.some((l) => l.jobId === jobId && !l.isFixed)) {
      return v.vehicleId;
    }
  }
  return undefined;
}

/** Pin a draft-assigned job to its current vehicle (for regenerate seed). */
export function pinJobOnPlan(plan: DailySchedulePlan, jobId: string): DailySchedulePlan {
  const vehicleId = vehicleHoldingJob(plan, jobId);
  if (!vehicleId) return plan;
  return {
    ...plan,
    pins: { ...(plan.pins ?? {}), [jobId]: vehicleId },
  };
}

export function unpinJobOnPlan(plan: DailySchedulePlan, jobId: string): DailySchedulePlan {
  if (!plan.pins?.[jobId]) return plan;
  const pins = { ...plan.pins };
  delete pins[jobId];
  return { ...plan, pins };
}

/** Drop pin when job leaves vehicles (unassign). */
export function clearPinIfPresent(plan: DailySchedulePlan, jobId: string): DailySchedulePlan {
  return unpinJobOnPlan(plan, jobId);
}

/** After reassign: keep pin only if job was pinned, pointing at new vehicle. */
export function retargetPin(
  plan: DailySchedulePlan,
  jobId: string,
  vehicleId: string
): DailySchedulePlan {
  if (!plan.pins?.[jobId]) return plan;
  return {
    ...plan,
    pins: { ...plan.pins, [jobId]: vehicleId },
  };
}
